import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './component.scss'

import './images/question.svg'

const showTooltip = () => {
  // セレクタ定義
  const ROOT_TARGET_SELECTOR = '.js-showTooltip-root-target'
  const LABEL_TARGET_SELECTOR = '.js-showTooltip-trigger'
  const CONTENTS_TARGET_SELECTOR = '.js-showTooltip-target'

  // 表示状態のクラス定義
  const SHOW_CLASS_NAME = 'tooltip__contents--show'

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $labelTarget = $(root).find(LABEL_TARGET_SELECTOR)
    const $contentsTarget = $(root).find(CONTENTS_TARGET_SELECTOR)

    // マウスオーバー時の処理
    $labelTarget.on('mouseenter', () => {
      $contentsTarget.addClass(SHOW_CLASS_NAME)

      if ($contentsTarget.is(':animated')) return

      $contentsTarget.fadeIn(200)
    })

    // マウスが離れた時の処理
    $labelTarget.on('mouseleave', () => {
      $contentsTarget.removeClass(SHOW_CLASS_NAME)
      $contentsTarget.fadeOut(200)
    })

    // スマホ用のクリックイベント
    $labelTarget.on('click', () => {
      if (!$contentsTarget.is(':animated') && $contentsTarget.hasClass(SHOW_CLASS_NAME)) {
        $contentsTarget.removeClass(SHOW_CLASS_NAME)
        $contentsTarget.fadeOut(200)
      } else {
        $contentsTarget.addClass(SHOW_CLASS_NAME)
        $contentsTarget.fadeIn(200)
      }
    })
  })
}

$(() => {
  // ツールチップの表示処理
  showTooltip()
})
